// Port of api/fuel/app/classes/filter/package/users.php
// JS note:
// - this is the offline package bootstrap for Filter\\Users
// - it exists to keep users/* controllers thin and let model/entity packaging own the response shape
import User from 'offline/model/user'
import UserEntity from 'offline/filter/package/users/user'

export default {
	run: function(config, filter, data, global) {
		var resultIds = data.results || []
		global.results = {}

		if (resultIds.length) {
			global.results = User.where([
				['user_id', 'in', resultIds]
			]).associated('user_id')
		}

		var results = []
		for (var i = 0; i < resultIds.length; i++) {
			var result = UserEntity.run(resultIds[i], { id: resultIds[i] }, global, config, filter)
			if (result) results.push(result)
		}

		return [results, { nested: {} }]
	}
}
